/**
 * AI 生成代码所需的全局库 - 懒加载版本
 * 只在首次使用时才加载这些库，避免影响首页加载速度
 */

// 缓存已加载的库
let librariesCache: any = null;
let loadingPromise: Promise<any> | null = null;

/**
 * 异步加载所有 AI 库
 * 使用单例模式，确保只加载一次
 */
export async function loadAILibraries() {
  // 如果已经加载过，直接返回缓存
  if (librariesCache) {
    return librariesCache;
  }

  // 如果正在加载中，返回相同的 Promise
  if (loadingPromise) {
    return loadingPromise;
  }

  // 开始加载
  loadingPromise = (async () => {
    console.log('[AI Libraries] 开始加载...');
    const startTime = performance.now();

    // 并行加载所有库
    const [
      mathjs,
      lodash,
      Plotly,
      { Chart, registerables },
      Papa,
      XLSX,
      Tone,
      mammoth,
      tf,
      THREE,
    ] = await Promise.all([
      import('mathjs'),
      import('lodash'),
      import('plotly.js'),
      import('chart.js'),
      import('papaparse'),
      import('xlsx'),
      import('tone'),
      import('mammoth'),
      import('@tensorflow/tfjs'),
      import('three'),
    ]);

    // 注册 Chart.js 组件
    Chart.register(...registerables);

    // 构建库对象
    const libraries = {
      mathjs,
      lodash,
      _: lodash,
      Plotly,
      Chart,
      Papa,
      XLSX,
      Tone,
      mammoth,
      tf,
      THREE,
    };

    // 挂载到全局 window 对象，供 iframe/动态代码使用
    if (typeof window !== 'undefined') {
      (window as any).mathjs = mathjs;
      (window as any)._ = lodash;
      (window as any).Plotly = Plotly;
      (window as any).Chart = Chart;
      (window as any).Papa = Papa;
      (window as any).XLSX = XLSX;
      (window as any).Tone = Tone;
      (window as any).mammoth = mammoth;
      (window as any).tf = tf;
      (window as any).THREE = THREE;
    }

    // 缓存结果
    librariesCache = libraries;

    const endTime = performance.now();
    console.log(
      `[AI Libraries] 加载完成，耗时: ${(endTime - startTime).toFixed(2)}ms`
    );

    return libraries;
  })();

  return loadingPromise;
}

/**
 * 同步获取已加载的库
 * 如果还未加载，返回空对象
 */
export function getAILibraries() {
  return librariesCache || {};
}

/**
 * 检查库是否已加载
 */
export function isLibrariesLoaded() {
  return librariesCache !== null;
}

// 默认导出懒加载函数
export default loadAILibraries;
